export const DASHBOARD_READY = 'REVENUE_BASED_LOAN_DASHBOARD_READY';
export const ACTIVATE_RBL_DASHBOARD = 'page/RBL_DASHBOARD [activate]';
export const APPROVED_DASHBOARD_READY =
    'REVENUE_BASED_LOAN_APPROVED_DASHBOARD_READY';
export const OUTSTANDING_DASHBOARD_READY =
    'REVENUE_BASED_LOAN_OUTSTANDING_DASHBOARD_READY';
